export const faqData = [
  {
    id: 1,
    question: "چگونه می‌توانم از پلتفرم شما استفاده کنم؟",
    answer:
      "برای استفاده از پلتفرم، کافیست یک عکس از برگه آزمایش خود بگیرید و آن را بارگذاری کنید. پلتفرم ما به‌طور خودکار اطلاعات را استخراج و تحلیل می‌کند.",
  },
  {
    id: 2,
    question: "نتایج آزمایش من چقدر سریع تحلیل می‌شوند؟",
    answer:
      "نتایج آزمایش شما در کمتر از سه دقیقه تحلیل و تفسیر می‌شوند و می‌توانید به‌سرعت به اطلاعات مورد نیاز دسترسی پیدا کنید.",
  },
  {
    id: 3,
    question: "آیا نیاز به دانش پزشکی برای استفاده از پلتفرم دارم؟",
    answer:
      "خیر! پلتفرم ما به گونه‌ای طراحی شده که نتایج پیچیده آزمایش‌ها را به زبانی ساده و قابل‌فهم ارائه می‌دهد، بنابراین نیازی به دانش پزشکی ندارید.",
  },
  {
    id: 4,
    question: "آیا اطلاعات من امن است؟",
    answer:
      "بله، ما به حفظ حریم خصوصی و امنیت اطلاعات شما متعهد هستیم. تمامی داده‌ها با استفاده از پروتکل‌های امنیتی مناسب محافظت می‌شوند.",
  },
  {
    id: 5,
    question: "اگر نتیجه آزمایش من غیرنرمال باشد، چه کاری باید انجام دهم؟",
    answer:
      "ما نتایج را به شما گزارش خواهیم داد و در صورت نیاز، توصیه می‌کنیم که با پزشک خود مشورت کنید تا راهنمایی‌های لازم را دریافت کنید.",
  },
];
